// extracted by mini-css-extract-plugin
export default {"giftsWrapper":"giftCardWallet_giftsWrapper__gjwjH","infiniteScrollerEndMessage":"giftCardWallet_infiniteScrollerEndMessage__W6NpT"};